// extracted by mini-css-extract-plugin
export default {"image":"background__image__GPDLG","color":"background__color__wJCK9","video":"background__video__u22CO","videoEnabled":"background__videoEnabled__F2Ofj"};